(function () {
  function init(root) {
    if (root.dataset.lcInit) return;
    root.dataset.lcInit = "1";

    var slides = root.querySelectorAll(".lc-reviews__slide");
    if (!slides.length) return;
    var dotsBox = root.querySelector(".lc-reviews__dots");
    var speed = parseInt(root.dataset.autoplay || "0", 10);
    var i = 0;
    var timer;

    slides.forEach(function (s, idx) {
      var d = document.createElement("span");
      d.className = "lc-reviews__dot" + (idx === 0 ? " is-active" : "");
      d.addEventListener("click", function () {
        go(idx);
        reset();
      });
      dotsBox.appendChild(d);
    });
    var dots = dotsBox.querySelectorAll(".lc-reviews__dot");

    function go(n) {
      slides[i].classList.remove("is-active");
      dots[i].classList.remove("is-active");
      i = (n + slides.length) % slides.length;
      slides[i].classList.add("is-active");
      dots[i].classList.add("is-active");
    }

    root.querySelectorAll(".lc-reviews__arrow").forEach(function (b) {
      b.addEventListener("click", function () {
        go(i + (b.dataset.dir === "next" ? 1 : -1));
        reset();
      });
    });

    function start() {
      if (speed > 0) timer = setInterval(function () { go(i + 1); }, speed);
    }
    function reset() {
      clearInterval(timer);
      start();
    }
    start();
  }

  function initAll() {
    document.querySelectorAll("[data-lc-reviews]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  // Re-init when added/edited in the theme editor
  document.addEventListener("shopify:section:load", initAll);
})();
